var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Badge } from '../Badge';
const imageStyles = css `
  height: ${styleUtils.rem(20)};
`;
const imageContainerStyles = css `
  ${styleUtils.hiddenScrollbarStyles}
  ${imageStyles}
  overflow: hidden;
`;
const variations = {
    copperFoil: {
        background: 'linear-gradient(353deg, rgba(0, 0, 0, 0.13) 5.76%, rgba(0, 0, 0, 0.00) 31.06%), linear-gradient(273deg, rgba(168, 117, 100, 0.24) -8.67%, rgba(255, 179, 157, 0.70) 70.38%, rgba(155, 104, 87, 0.29) 111.79%), #a6523e',
        color: theme.colors.gray100,
        text: 'Real foil',
    },
    editorsPick: {
        background: '#b36955',
        color: theme.colors.accent100,
        text: 'Editor\'s Pick',
    },
    gloss: {
        background: 'linear-gradient(to bottom right, rgba(237, 255, 254, 0.93) 3%, rgba(243, 255, 242, 0.93) 6%, rgba(245, 255, 237, 0.93) 6%, rgba(255, 237, 237, 0.93) 9%, rgba(255, 237, 237, 0.00) 12%, rgba(253, 245, 245, 0.00) 20%, rgba(251, 251, 251, 0.00) 27%, rgba(251, 246, 255, 0.93) 31%, rgba(207, 245, 253, 0.93) 35%, rgba(248, 255, 226, 0.93) 40%, rgba(253, 220, 220, 0.93) 44%, rgba(244, 244, 244, 0.00) 48%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, rgba(237, 255, 254, 0.93) 3%, rgba(243, 255, 242, 0.93) 6%, rgba(245, 255, 237, 0.93) 6%, rgba(255, 237, 237, 0.93) 9%, rgba(255, 237, 237, 0.00) 12%, rgba(253, 245, 245, 0.00) 20%, rgba(251, 251, 251, 0.00) 27%, rgba(251, 246, 255, 0.93) 31%, rgba(207, 245, 253, 0.93) 35%, rgba(248, 255, 226, 0.93) 40%, rgba(253, 220, 220, 0.93) 44%, rgba(244, 244, 244, 0.00) 48%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, rgba(237, 255, 254, 0.93) 3%, rgba(243, 255, 242, 0.93) 6%, rgba(245, 255, 237, 0.93) 6%, rgba(255, 237, 237, 0.93) 9%, rgba(255, 237, 237, 0.00) 12%, rgba(253, 245, 245, 0.00) 20%, rgba(251, 251, 251, 0.00) 27%, rgba(251, 246, 255, 0.93) 31%, rgba(207, 245, 253, 0.93) 35%, rgba(248, 255, 226, 0.93) 40%, rgba(253, 220, 220, 0.93) 44%, rgba(244, 244, 244, 0.00) 48%) top left / 50% 50% no-repeat, linear-gradient(to top right, rgba(237, 255, 254, 0.93) 3%, rgba(243, 255, 242, 0.93) 6%, rgba(245, 255, 237, 0.93) 6%, rgba(255, 237, 237, 0.93) 9%, rgba(255, 237, 237, 0.00) 12%, rgba(253, 245, 245, 0.00) 20%, rgba(251, 251, 251, 0.00) 27%, rgba(251, 246, 255, 0.93) 31%, rgba(207, 245, 253, 0.93) 35%, rgba(248, 255, 226, 0.93) 40%, rgba(253, 220, 220, 0.93) 44%, rgba(244, 244, 244, 0.00) 48%) top right / 50% 50% no-repeat, #EDE5F8;',
        color: theme.colors.accent700,
        text: 'Real gloss',
    },
    goldFoil: {
        background: 'linear-gradient(92deg, rgba(248, 211, 151, 0.42) 0%, #BF9A60 43.12%, #EFCB98 55.05%, rgba(142, 119, 83, 0.41) 84.41%), #A77831;',
        color: theme.colors.gray100,
        text: 'Real foil',
    },
    grandCard: {
        background: theme.colors.gray200,
        color: theme.colors.accent700,
        text: 'Grand card',
    },
    handLettered: {
        background: theme.colors.gray200,
        color: theme.colors.accent700,
        text: 'Hand lettered design',
    },
    letterpress: {
        background: '#f1f1f1',
        color: '#ee1b4d',
        text: 'Letterpress',
    },
    winner: {
        background: theme.colors.accent700,
        color: theme.colors.gray200,
        text: 'Winner',
    },
};
const FeaturedAttribute = (_a) => {
    var { modifier } = _a, props = __rest(_a, ["modifier"]);
    const featuredAttributeStyles = useMemo(() => (css `
        ${modifier !== 'custom' && css `
          background: ${variations[modifier].background};
          color: ${variations[modifier].color};
        `}
      `), [
        modifier,
    ]);
    return (modifier === 'custom'
        ? (_jsx("div", Object.assign({ css: imageContainerStyles }, { children: _jsx("img", { alt: 'alt' in props ? props.alt : undefined, css: imageStyles, src: 'src' in props ? props.src : undefined }) })))
        : (_jsx("div", { children: _jsx(Badge, Object.assign({ css: featuredAttributeStyles, size: "small", type: "custom" }, { children: variations[modifier].text })) })));
};
export { FeaturedAttribute };
